import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { FontsService, Font } from '../../../services/fonts.service';
import { AuthService } from '../../../services/auth.service';

@Component({
	selector: 'app-map',
	templateUrl: './map.component.html',
	styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('mapForm', { static: true }) mapForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	font: Font;
	fonts: Array<Font>;
	formChangeSubscription: Subscription;
	isAdmin;

	constructor(private comService: ComponentService, private fontsService: FontsService, private auth: AuthService) {
		this.fonts = this.fontsService.getFonts();
	}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();
		this.formChangeSubscription = this.mapForm.valueChanges
			.pipe(
				tap(() => this.comService.updateDisabledSave(this.mapForm.invalid || this.nameField.editComponentName)),
				filter((form) => this.mapForm.valid),
				debounceTime(2000)
			)
			.subscribe();

		const userFont: Array<Font> = this.fonts.filter((font) => font.url === this.componentData.config.nav_text.font);

		if (userFont.length) {
			this.font = userFont[0];
		} else {
			this.font = this.fonts[0];
			if (this.componentData.config.nav_text.font && this.componentData.config.nav_text.font.length) {
				this.font.url = this.componentData.config.nav_text.font;
			}
		}

		if (!('include' in this.componentData.config.nav_text)) {
			this.componentData.config.nav_text.include = true;
		}
	}

	ngOnDestroy() {
		this.formChangeSubscription.unsubscribe();
	}

	renderWidget() {
		if (this.mapForm.valid) {
			this.comService.updateComponentData(this.componentData);
			this.comService.updatePreviewData();
		}
	}

	onAddressChange(event, location) {
		const cords = event.lat + ',' + event.lng;
		this.componentData.config.location = cords;
		this.componentData.config.address = event.address;
	}

	onFontFamilyChange(font): void {
		this.componentData.config.nav_text.font = font.url;
	}
}
